import { useEffect, useRef } from 'react';
import { axiosSSO } from 'config';
import { useFeatureFlag } from 'hooks/useFeatureFlag';
import { handleResponseInterceptorError, handleResponseError } from 'utils/axiosHelper';

export default function useInterceptors() {
    const { isKeycloakIntegrationEnabled } = useFeatureFlag();
    const interceptors = useRef({ responseInterceptorId: null });

    useEffect(() => {
        // Eject previous interceptor
        if (interceptors.current.responseInterceptorId !== null) {
            axiosSSO.interceptors.response.eject(interceptors.current.responseInterceptorId);
        }

        // Determine response interceptor based on feature flag
        const responseInterceptor = isKeycloakIntegrationEnabled ? handleResponseInterceptorError : handleResponseError;

        // Add new interceptor
        const responseInterceptorId = axiosSSO.interceptors.response.use(
            (response) => response,
            (error) => responseInterceptor(error)
        );

        // Store ID for cleanup
        interceptors.current = { responseInterceptorId: responseInterceptorId };

        // Cleanup on unmount or next run
        return () => {
            axiosSSO.interceptors.response.eject(responseInterceptorId);
            interceptors.current = { responseInterceptorId: null };
        };
    }, [isKeycloakIntegrationEnabled]);
}
